
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whatsapp-santander",
      function () {
        return require("private-next-pages/whatsapp-santander.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whatsapp-santander"])
      });
    }
  